// extracted by mini-css-extract-plugin
export default {"upload-image-wrap":"UploadFile_upload-image-wrap__JG6ID","avatar-box":"UploadFile_avatar-box__XAh1r","errors-wrap":"UploadFile_errors-wrap__jByL6"};